import { Configuration } from '../types/configuration';
import { LOCAL_APP_CONFIG } from './app-config/local-app-config';
import { DEV_APP_CONFIG } from './app-config/dev-app-config';
import { STAGING_APP_CONFIG } from './app-config/staging-app-config';
import { PROD_APP_CONFIG } from './app-config/prod-app-config';

const CONFIG_MAP: Record<string, Configuration> = {
  local: LOCAL_APP_CONFIG,
  dev: DEV_APP_CONFIG,
  staging: STAGING_APP_CONFIG,
  prod: PROD_APP_CONFIG,
};

export const getAppConfig = (): Configuration => {
  const env = (process.env.ENVIRONMENT || 'local').toLowerCase();
  return CONFIG_MAP[env] ?? LOCAL_APP_CONFIG;
};
